import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, UnitFormatter} from "../../../../../utils/formatters";
import React from "react";
import Select from "../../../../form/Select";
import {componentFilter} from "../../../../../utils/filters";

const sortable = true;
const filterable = true;

export default (props) => <div className="row form-row">
    <div className="col-md-12">
        {props.values[props.componentConfig.idfield] && <SelectorGrid
            className={"p-small-table"}
            view={["unit"]}
            aggregations={{
                fields: {
                    "totalprice": {
                        field: "totalprice", type: "SUM"
                    },
                    "qty": {
                        field: "qty", type: "SUM"
                    },
                }
            }}
            columns={{
                "name": {
                    header: 'Megnevezés',
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Listaár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "discount": {
                    header: "Kedvezmény",
                    width: 1,
                    className: "discount",
                    renderer:
                        (value) => {
                            return <span className="discount">{value + "%"}</span>;
                        }
                },
                "vat": {
                    header: "Áfa",
                    width: "vat",
                    sortable,
                    filterable: componentFilter({component: "vatrate"}),
                    renderer: (value) => <span className="vat">{value.name}</span>
                },
                "saleprice": {
                    header: 'Eladási Ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "qty": {
                    header: 'Mennyiség',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "nettotalprice": {
                    header: "Nettó Összesen",
                    width: 1,
                    renderer: CurrencyFormatter
                },
                "totalprice": {
                    header: "Bruttó Összesen",
                    width: 1,
                    renderer: CurrencyFormatter
                }
            }}
            listfield={"items"}
            data={props.values}
            orderBy={{
                field: "name",
                direction: "ASC"
            }}
            componentConfig={props.componentConfig}
        />}
    </div>
</div>;